module.exports = __webpack_public_path__ + "37f344e43627650cb10e1f499d1fb090.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-earth-s.png
// module id = 1907
// module chunks = 0